// 个人账户续约
import { get, post } from './request' 

// 个人账户续约 - 首页提示
export function personAccountTip(data) {
  return get('/channel_admin/person_account/tip', data)
}
// 个人账户续约 - 获取用户基本信息
export function personAccountInfo(data) {
  return get('/channel_admin/person_account/info', data)
}
// 个人账户续约 - 发送验证码
export function personAccountSendCodeMessage(data) {
  return post('/channel_admin/person_account/send_message', data)
}
// 个人账户续约 - 查看合同
export function personAccountAgreement(data) {
  return get('/channel_admin/person_account/agreement', data)
}
// 个人账户续约 - 续约确认，同意延长
export function personAccountApplyRenewal(data) {
  return post('/channel_admin/person_account/info', data)
}
